module.exports = __webpack_public_path__ + "front/img/d6.072a27c8.png";